import React from 'react';
import SectionHeading from './SectionHeading';

const Experience = function({ lang, isDark, sections, experience }) {
  return (
    <section id="experience" className="mb-10" aria-labelledby="exp-heading">
      <div className="section-card">
        <SectionHeading id="exp-heading" isDark={isDark}>{sections.experience}</SectionHeading>
        <div className="space-y-9">
          {experience.map((item, i) => (
            <article key={i} className={`group flex flex-col rounded-lg -mx-3 px-3 py-2 transition-colors duration-300 print:hover:bg-transparent ${isDark ? 'hover:bg-white/[0.03]' : 'hover:bg-slate-100/80'}`}>
              <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1 mb-1.5">
                <h3 className={`text-[16px] font-bold ${isDark ? 'text-slate-100' : 'text-slate-900'}`}>
                  {item.company} <span className="font-normal mx-1 opacity-60">—</span> <span className="font-normal">{item.title}</span>
                </h3>
                <span className={`text-[11px] font-mono tracking-wide ${isDark ? 'text-slate-400' : 'text-slate-500'} whitespace-nowrap`}>
                  {item.period}
                </span>
              </div>
              {item.techStack && (
                <div className="flex flex-wrap gap-2 mb-3 mt-1">
                  {item.techStack.replace('Tech: ', '').split(', ').map((tech, tIdx) => (
                    <span key={tIdx} className={`px-2 py-0.5 rounded-md text-[11px] font-bold tracking-wide border ${isDark ? 'bg-blue-500/10 text-blue-300 border-blue-500/20' : 'bg-blue-50 text-blue-700 border-blue-200'}`}>
                      {tech}
                    </span>
                  ))}
                </div>
              )}
              <ul className="space-y-2 ml-4 list-outside list-disc marker:text-slate-400">
                {item.highlights.map((h, j) => {
                  const highlightedText = h.replace(/(\d+\+?\s*(?:tables|REST API endpoints|admin pages|major events)?)/g, (match) =>
                    `<span class="font-bold ${isDark ? 'text-blue-300' : 'text-blue-600'}">${match}</span>`
                  );
                  return (
                    <li
                      key={j}
                      className={`text-[14px] leading-relaxed pl-1 ${isDark ? 'text-slate-300' : 'text-slate-700'}`}
                      dangerouslySetInnerHTML={{ __html: highlightedText }}
                    />
                  );
                })}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default React.memo(Experience);
